/* eslint-disable func-style */
import { yodaStakeholderConstants } from "../constants";
import { yodaStakeholderService } from "../services";

export const yodaStakeholderActions = {
  getAll,
  getMe,
  getOrderHistory,
  resetOrderHistory,
  getOrderHistoryNewCount,
  reset,
};

function getAll() {
  return (dispatch) => {
    dispatch(request());

    yodaStakeholderService.getAll().then(
      (response) => {
        if (
          response.results !=
          null /* && response.results != undefined && response.results.length > 0 */
        ) {
          const { results } = response;
          dispatch(success(results));
        } else {
          dispatch(failure(response));
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function request() {
    return { type: yodaStakeholderConstants.GETALL_REQUEST };
  }
  function success(stakeholder) {
    return {
      type: yodaStakeholderConstants.GETALL_SUCCESS,
      payload: { stakeholder },
    };
  }
  function failure(error) {
    return {
      type: yodaStakeholderConstants.GETALL_FAILURE,
      payload: { error },
    };
  }
}

function getMe() {
  return (dispatch) => {
    dispatch(request());

    yodaStakeholderService.getMe().then(
      (response) => {
        if (
          response?.role /* && response.results != undefined && response.results.length > 0 */
        ) {
          dispatch(success(response));
        } else {
          dispatch(success({ error: "not-authorized" }));
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function request() {
    return { type: yodaStakeholderConstants.GETME_REQUEST };
  }
  function success(me) {
    return { type: yodaStakeholderConstants.GETME_SUCCESS, payload: { me } };
  }
  function failure(error) {
    return { type: yodaStakeholderConstants.GETME_FAILURE, payload: { error } };
  }
}

function resetOrderHistory() {
  return { type: yodaStakeholderConstants.ORDER_HISTORY_RESET };
}

function getOrderHistory() {
  return (dispatch) => {
    dispatch(request());

    yodaStakeholderService.getOrderHistory().then(
      (response) => {
        dispatch(success(response?.results || []));
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function request() {
    return { type: yodaStakeholderConstants.GET_ORDER_HISTORY_REQUEST };
  }
  function success(orderHistory) {
    return {
      type: yodaStakeholderConstants.GET_ORDER_HISTORY_SUCCESS,
      payload: { orderHistory },
    };
  }
  function failure(error) {
    return {
      type: yodaStakeholderConstants.GET_ORDER_HISTORY_FAILURE,
      payload: { error },
    };
  }
}

function getOrderHistoryNewCount() {
  return (dispatch) => {
    dispatch(request());

    yodaStakeholderService.getOrderHistoryNewCount().then(
      (count) => {
        dispatch(success(count || 0));
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function request() {
    return {
      type: yodaStakeholderConstants.GET_ORDER_HISTORY_NEW_COUNT_REQUEST,
    };
  }
  function success(orderHistoryNewCount) {
    return {
      type: yodaStakeholderConstants.GET_ORDER_HISTORY_NEW_COUNT_SUCCESS,
      payload: { orderHistoryNewCount },
    };
  }
  function failure(error) {
    return {
      type: yodaStakeholderConstants.GET_ORDER_HISTORY_NEW_COUNT_FAILURE,
      payload: { error },
    };
  }
}

function reset() {
  return (dispatch) => {
    dispatch(request());
  };

  function request() {
    return { type: yodaStakeholderConstants.RESET };
  }
}
